export default "__VITE_ASSET__DO5zw9RT__"